const login = {
  title: "Welcome",
  subTitle: "Sign in to Get Started",
  subTitle2: "in",
  pageTitle: "Login",
  pageSubtitle: "Enter your account details to log in.",
  labels: {
    email: "Email",
    emailAddress: "Email Address",
    password: "Password",
    remember: "Remember me next time",
    forgetPassword: "Forget your password?",
    forgotPasswordPrefix: "Forgot Password ?",
    resetPasswordLink: "Reset Password",
    registerFooter: "Don't have an account?",
    registerCompany: "Register your company",
    signin: "Sign in",
    logIn: "Log in",
    admin: "Admin",
    supervisor: "Supervisor",
    signInAsSupervisor: "Login as a supervisor",
    otherRole: "Other Role",
    visitorRole: "Employee",
    client: "Client",
    signInAs: "Account type",
  },
  placeholders: {
    email: "useremail@example.com",
    password: "Enter password",
  },
  // A user of an Inactive company signs in (PROLINE-4124).
  deactivatedAccount: {
    title: "This Account Has Been Deactivated",
    description:
      "Your company's access has been suspended by a Yoram administrator. Please contact our support team for more information.",
    supportTitle: "YORAM SUPPORT",
    backToSignIn: "Back to Sign In",
  },
};

export default login;
